define('models/zendesk/SectionModel',['underscore','ObjectModel','LocalStorage','app'],
    function (_,ObjectModel,LocalStorage,app) {
    //
    // Model Zendesk Section
    //
    return ObjectModel.extend({

        name:'ZendeskSectionModel',
        idAttribute:'id',

        getName:function(){
           return this.get('name');
        },

        getUrl:function(){
            // on part du postulat que les section n'ont qu'un article
            var article = this.getArticles().first();
            return article ? article.getUrl() : '#';
        },

        isCurrent:function(){
            var model = this,
                isCurrent = false,
                article = model.collection.supportCenter.getCurrentArticle();
            if(article){
                isCurrent = article.get('section_id') == model.id;
            }
            return isCurrent;
        },

        getCategory:function(){
            var model = this,
                category_id = model.get('category_id'),
                category = model.collection.supportCenter.getCategory(category_id);
            return category;
        },

        getArticles:function(){
            var model = this,
                section_id = model.id,
                articles = model.collection.supportCenter.getArticles().where({section_id:section_id});
            return _(articles);
        },

        getOrderHelpText:function(){
            var article = this.getArticle();
            if(article){
                var configurationName = '_ZENDESK_ORDER_HELP_TEXT_'+article.get('id_internal')+'_';
                return app.c(configurationName,article.getBody());
            }
        },

        getForm:function(){
            // return the form of the first article
            var article = this.getArticle();
            if(article) return article.getForm();
        },

        getArticle:function(){
            // return the first article
            var articles = this.getArticles();
            if(articles) return articles.first()
        },

        isOrder:function(isComplete){
            var articles = this.getArticles(),
                find = articles.find(function(article){
                    return article.isOrder(isComplete);
                });
            return !!find;
        }

    });

});
